/**
 * @page EmailSettingsPage
 * @description 日結報表 Email 設定（UI-4-5）
 * 設定自動寄送報表的收件人
 */

import { useTranslation } from 'react-i18next';

export default function EmailSettingsPage() {
  const { t } = useTranslation('accounting');
  const { t: tc } = useTranslation('common');

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h1 className="text-2xl font-bold text-base-content mb-2">{t('emailSettingsTitle')}</h1>
      <p className="text-sm text-base-content/60 mb-6">{t('emailSettingsDesc')}</p>

      <div className="bg-base-200 border border-base-300 rounded-xl p-5 space-y-4">
        <div>
          <label className="block text-sm text-base-content/70 mb-1.5">
            {t('recipientEmails')}
          </label>
          <textarea
            rows={5}
            placeholder="example@example.com&#10;manager@example.com"
            className="w-full px-3 py-2 rounded-md border border-base-300 bg-base-200 text-base-content text-sm
                       focus:outline-hidden focus:ring-2 focus:ring-primary resize-none"
          />
        </div>
        <div>
          <label className="block text-sm text-base-content/70 mb-1.5">{t('sendTime')}</label>
          <select
            className="w-full px-3 py-2 rounded-md border border-base-300 bg-base-200 text-base-content text-sm
                             focus:outline-hidden focus:ring-2 focus:ring-primary"
          >
            <option>{t('sendAfterSettle')}</option>
            <option>{t('sendAt2300')}</option>
            <option>{t('noAutoSend')}</option>
          </select>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-md p-3 text-xs text-amber-700">
          {t('smtpWarning')}
        </div>
      </div>

      <div className="flex justify-end gap-3 mt-6">
        <button className="px-4 py-2 rounded-md border border-base-300 text-sm">
          {tc('cancel')}
        </button>
        <button className="px-4 py-2 rounded-md bg-primary text-primary-content text-sm">
          {tc('save')}
        </button>
      </div>
    </div>
  );
}
